import React from 'react'
import './DebugPanel.css'

interface ApiCall {
  timestamp: string
  method: string
  url: string
  status: number
  request?: any
  response?: any
  error?: string
}

interface DebugPanelProps {
  isVisible: boolean
  onToggle: () => void
  apiCalls: ApiCall[]
  onClear: () => void
}

const DebugPanel: React.FC<DebugPanelProps> = ({ isVisible, onToggle, apiCalls, onClear }) => {
  if (!isVisible) {
    return (
      <button className="debug-toggle" onClick={onToggle}>
        🔧 Debug
      </button>
    )
  }

  return (
    <div className="debug-panel">
      <div className="debug-header">
        <h3>🔧 Debug Panel</h3>
        <div className="debug-controls">
          <button onClick={onClear} className="debug-clear">Clear</button>
          <button onClick={onToggle} className="debug-close">×</button>
        </div>
      </div>
      
      <div className="debug-content">
        <div className="debug-stats">
          <div className="stat">
            <span className="stat-label">Total Calls:</span>
            <span className="stat-value">{apiCalls.length}</span>
          </div>
          <div className="stat">
            <span className="stat-label">Success Rate:</span>
            <span className="stat-value">
              {apiCalls.length > 0 ? 
                Math.round((apiCalls.filter(call => call.status < 400).length / apiCalls.length) * 100) + '%' : 
                'N/A'
              }
            </span>
          </div>
        </div>

        <div className="api-calls">
          <h4>API Calls ({apiCalls.length})</h4>
          {apiCalls.length === 0 ? (
            <p className="no-calls">No API calls yet. Upload an image to test!</p>
          ) : (
            <div className="calls-list">
              {apiCalls.slice().reverse().map((call, index) => (
                <div key={index} className={`api-call ${call.status >= 400 ? 'error' : 'success'}`}>
                  <div className="call-header">
                    <span className="call-method">{call.method}</span>
                    <span className="call-url">{call.url}</span>
                    <span className={`call-status status-${Math.floor(call.status / 100)}`}>
                      {call.status}
                    </span>
                    <span className="call-time">{call.timestamp}</span>
                  </div>
                  
                  {call.request && (
                    <details className="call-details">
                      <summary>Request</summary>
                      <pre>{JSON.stringify(call.request, null, 2)}</pre>
                    </details>
                  )}
                  
                  {call.response && (
                    <details className="call-details">
                      <summary>Response</summary>
                      <pre>{JSON.stringify(call.response, null, 2)}</pre>
                    </details>
                  )}
                  
                  {call.error && (
                    <div className="call-error">
                      <strong>Error:</strong> {call.error}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DebugPanel